module.exports = __webpack_public_path__ + "static/media/cross-icon.961d2a3a.png";